import api from '@common/api/index.js'
import dateTool from '@/utils/dateTool.js'

export default {
  /**
   * 获取物业营收页面数据
   * @param {*} dateType 时间类型 1：年 2：月
   * @param {*} time 时间字符串
   * @param {*} companyId 业主公司 默认传0
   * @param {*} status 状态  默认传 -1
   */
  getDataForProperty(dateType, time, companyId, status) {
    let startTime = ''
    let endTime = ''
    return new Promise((resolve, reject) => {
      let xData = []
      let timets = new Date(time)
      if (dateType == 1) {
        for (let i = 1; i < 13; i++) {
          xData.push(i + '月')
        }
        startTime = dateTool.format(timets, 'yyyy') + '/01/01 00:00:00'
        let time2 = new Date(startTime)
        time2.setFullYear(time2.getFullYear() + 1)
        endTime = dateTool.format(time2, 'yyyy') + '/01/01 00:00:00'
      } else {
        let days = new Date(
          timets.getFullYear(),
          timets.getMonth() + 1,
          0
        ).getDate()
        for (let i = 1; i <= days; i++) {
          xData.push(i + '号')
        }
        startTime = dateTool.format(timets, 'yyyy/MM') + '/01 00:00:00'
        let time2 = new Date(startTime)
        time2.setMonth(time2.getMonth() + 1)
        endTime = dateTool.format(time2, 'yyyy/MM') + '/01 00:00:00'
      }

      let result = {
        // 收入
        income: {
          // 托管
          trusteeship: 0,
          // 租凭
          rental: 0,
          // 总和
          total: 0,
        },
        // 支出
        expend: {
          // 托管
          trusteeship: 0,
          // 总和
          total: 0,
        },
        // 收入支出总体情况
        incomeAndExpend: 0,
        // 收入支出总体情况趋势
        incomeAndExpendData: [],
        // 托管支出总体情况趋势
        trusteeshipData: [],
        // 租凭支出总体情况趋势
        rentalData: [],
        xData: [],
      }

      let apiArr = [
        api.rentalArea.getRentalAreaTrusteeshipIncomeBillForProperty(
          companyId,
          startTime,
          endTime,
          [],
          status
        ),
        api.rentalArea.getRentalAreaTrusteeshipExpenditureBillForProperty(
          companyId,
          startTime,
          endTime,
          [],
          status
        ),
        api.rentalArea.getLeaseIncomeBillForProperty(
          companyId,
          startTime,
          endTime,
          -1,
          [],
          status
        ),
      ]

      Promise.all(apiArr).then((resArr) => {
        let trusteeshipIncomeObj = null
        let trusteeshipExpendObj = null
        let rentalIncomeObj = null
        let incomeTotal = 0
        let expendTotal = 0
        let incomeAndExpendData = []
        let trusteeshipData = []
        let rentalData = []
        // 托管收入
        if (resArr[0].data) {
          const obj = this.calcData(resArr[0].data, dateType)
          result.income.trusteeship = obj.total.toFixed(2)
          incomeTotal += obj.total
          trusteeshipIncomeObj = obj.dateTotalObj
        }
        // 托管支出
        if (resArr[1].data) {
          const obj = this.calcData(resArr[1].data, dateType)
          result.expend.trusteeship = obj.total.toFixed(2)
          expendTotal += obj.total
          trusteeshipExpendObj = obj.dateTotalObj
        }
        // 租凭收入
        if (resArr[2].data) {
          const obj = this.calcData(resArr[2].data, dateType)
          result.income.rental = obj.total.toFixed(2)
          incomeTotal += obj.total
          rentalIncomeObj = obj.dateTotalObj
        }
        // 总情况 = 收入 - 支出
        result.incomeAndExpend = (incomeTotal - expendTotal).toFixed(2)

        for (let i = 1; i <= xData.length; i++) {
          // 托管支出总体情况趋势
          let trusteeshipTotal = 0
          if (trusteeshipIncomeObj[i]) {
            trusteeshipTotal += trusteeshipIncomeObj[i]
          }
          if (trusteeshipExpendObj[i]) {
            trusteeshipTotal -= trusteeshipExpendObj[i]
          }
          trusteeshipData.push(trusteeshipTotal)

          // 租凭支出总体情况趋势
          let rentalTotal = 0
          if (rentalIncomeObj[i]) {
            rentalTotal += rentalIncomeObj[i]
          }
          rentalData.push(rentalTotal)
          incomeAndExpendData.push(trusteeshipTotal + rentalTotal)
        }

        result.income.total = incomeTotal.toFixed(2)
        result.expend.total = expendTotal.toFixed(2)
        result.incomeAndExpendData = incomeAndExpendData
        result.trusteeshipData = trusteeshipData
        result.rentalData = rentalData
        result.xData = xData

        resolve(result)
      })
    })
  },
  /**
   * 获取业主营收页面数据
   * @param {*} dateType 时间类型 1：年 2：月
   * @param {*} time 时间字符串
   * @param {*} companyId 业主公司 默认传0
   * @param {*} status 状态  默认传 -1
   */
  getDataForProprietor(dateType, time, companyId, status) {
    let startTime = ''
    let endTime = ''
    time = new Date(time)
    return new Promise((resolve, reject) => {
      let xData = []
      if (dateType == 1) {
        for (let i = 1; i < 13; i++) {
          xData.push(i + '月')
        }
        startTime = dateTool.format(time, 'yyyy') + '/01/01 00:00:00'
        let time2 = new Date(startTime)
        time2.setFullYear(time2.getFullYear() + 1)
        endTime = dateTool.format(time2, 'yyyy') + '/01/01 00:00:00'
      } else {
        let days = new Date(time.getFullYear(), time.getMonth(), 0).getDate()
        for (let i = 1; i <= days; i++) {
          xData.push(i + '号')
        }
        startTime = dateTool.format(time, 'yyyy/MM') + '/01 00:00:00'
        let time2 = new Date(startTime)
        time2.setMonth(time2.getMonth() + 1)
        endTime = dateTool.format(time2, 'yyyy/MM') + '/01 00:00:00'
      }

      let result = {
        // 收入
        income: {
          // 托管
          trusteeship: 0,
          // 总和
          total: 0,
        },
        // 支出
        expend: {
          // 托管
          trusteeship: 0,
          // 总和
          total: 0,
        },
        // 收入支出总体情况
        incomeAndExpend: 0,
        // 收入支出总体情况趋势
        incomeAndExpendData: [],
      }

      let apiArr = [
        api.rentalArea.getRentalAreaTrusteeshipIncomeBillForProprietor(
          companyId,
          startTime,
          endTime,
          [],
          status
        ),
        api.rentalArea.getRentalAreaTrusteeshipExpenditureBillForProprietor(
          companyId,
          startTime,
          endTime,
          [],
          status
        ),
      ]

      Promise.all(apiArr).then((resArr) => {
        let trusteeshipIncomeObj = null
        let trusteeshipExpendObj = null
        let incomeTotal = 0
        let expendTotal = 0
        let incomeAndExpendData = []
        let trusteeshipData = []
        // 托管收入
        if (resArr[0].data) {
          const obj = this.calcData(resArr[0].data, dateType)
          result.income.trusteeship = obj.total
          incomeTotal += obj.total
          trusteeshipIncomeObj = obj.dateTotalObj
        }
        // 托管支出
        if (resArr[1].data) {
          const obj = this.calcData(resArr[1].data, dateType)
          result.expend.trusteeship = obj.total
          expendTotal += obj.total
          trusteeshipExpendObj = obj.dateTotalObj
        }
        // 总情况 = 收入 - 支出
        result.incomeAndExpend = (incomeTotal - expendTotal).toFixed(2)

        for (let i = 1; i <= xData.length; i++) {
          // 托管支出总体情况趋势
          let trusteeshipTotal = 0
          if (trusteeshipIncomeObj[i]) {
            trusteeshipTotal += trusteeshipIncomeObj[i]
          }
          if (trusteeshipExpendObj[i]) {
            trusteeshipTotal -= trusteeshipExpendObj[i]
          }
          incomeAndExpendData.push(trusteeshipTotal)
        }

        result.income.total = incomeTotal.toFixed(2)
        result.expend.total = expendTotal.toFixed(2)
        result.incomeAndExpendData = incomeAndExpendData
        result.xData = xData

        resolve(result)
      })
    })
  },
  /**
   * 获取租户营收页面数据
   * @param {*} dateType 时间类型 1：年 2：月
   * @param {*} time 时间字符串
   * @param {*} companyId 业主公司 默认传0
   * @param {*} status 状态  默认传 -1
   */
  getDataForLessee(dateType, time, companyId, status) {
    let startTime = ''
    let endTime = ''
    console.log(time)
    time = new Date(time)
    return new Promise((resolve, reject) => {
      let xData = []
      if (dateType === 1) {
        for (let i = 1; i < 13; i++) {
          xData.push(i + '月')
        }
        endTime = dateTool.format(time, 'yyyy/MM') + '/01 00:00:00'
        let time2 = new Date(endTime)
        time2.setFullYear(time2.getFullYear() - 1)
        startTime = dateTool.format(time2, 'yyyy/MM') + '/01 00:00:00'
      } else {
        let days = new Date(time.getFullYear(), time.getMonth(), 0).getDate()
        for (let i = 1; i <= days; i++) {
          xData.push(i + '号')
        }
        endTime = dateTool.format(time, 'yyyy/MM/dd') + ' 00:00:00'
        let time2 = new Date(endTime)
        time2.setMonth(time2.getMonth() - 1)
        startTime = dateTool.format(time2, 'yyyy/MM/dd') + ' 00:00:00'
      }

      let result = {
        // 收入
        income: {
          // 托管
          trusteeship: 0,
          // 总和
          total: 0,
        },
        // 支出
        expend: {
          // 托管
          trusteeship: 0,
          // 总和
          total: 0,
        },
        // 收入支出总体情况
        incomeAndExpend: 0,
        // 收入支出总体情况趋势
        incomeAndExpendData: [],
      }

      let apiArr = [
        api.rentalArea.getLeaseExpenditureBillForPersonalLessee(
          startTime,
          endTime,
          [],
          status
        ),
        api.rentalArea.getLeaseExpenditureBillForPersonalLessee(
          startTime,
          endTime,
          [],
          status
        ),
      ]

      Promise.all(apiArr).then((resArr) => {
        // let trusteeshipIncomeObj = null;
        let trusteeshipExpendObj = null
        let incomeTotal = 0
        let expendTotal = 0
        let incomeAndExpendData = []
        let trusteeshipData = []

        // 托管支出
        if (resArr[0].data) {
          const obj = this.calcData(resArr[0].data, dateType)
          result.expend.trusteeship = obj.total
          expendTotal += obj.total
          trusteeshipExpendObj = obj.dateTotalObj
        }
        // 总情况 = 收入 - 支出
        result.incomeAndExpend = expendTotal

        for (let i = 1; i <= xData.length; i++) {
          // 托管支出总体情况趋势
          let trusteeshipTotal = 0
          // if (trusteeshipIncomeObj[i]) {
          //   trusteeshipTotal += trusteeshipIncomeObj[i];
          // }
          if (trusteeshipExpendObj[i]) {
            trusteeshipTotal -= trusteeshipExpendObj[i]
          }
          trusteeshipData.push(trusteeshipTotal)
          incomeAndExpendData.push(trusteeshipTotal)
        }

        result.incomeAndExpendData = incomeAndExpendData
        result.trusteeshipData = trusteeshipData
        result.xData = xData

        resolve(result)
      })
    })
  },

  calcData(data, dateType) {
    let total = 0
    let dateTotalObj = {}
    for (let i = 0; i < data.length; i++) {
      total += data[i].totalAmount
      let totalAmount = 0
      const monthOrDayNum =
        dateType == 1
          ? new Date(data[i].startTime).getMonth() + 1
          : new Date(data[i].startTime).getDate()
      if (dateTotalObj[monthOrDayNum]) {
        totalAmount = data[i].totalAmount
        dateTotalObj[monthOrDayNum] += totalAmount
      } else {
        dateTotalObj[monthOrDayNum] = data[i].totalAmount
      }
    }

    return { total: total, dateTotalObj: dateTotalObj }
  },
}
